module.exports = __webpack_public_path__ + "static/media/item-green.48aec3a2.svg";